import { useEffect, useState, type RefObject } from "react";

export function useStickyAddToCartVisibility(
  regularButtonRef: RefObject<HTMLButtonElement | null>,
) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let animationFrame = 0;

    const updateVisibility = () => {
      const regularButton = regularButtonRef.current;

      if (!regularButton) {
        setIsVisible(false);
        return;
      }

      setIsVisible(regularButton.getBoundingClientRect().bottom < 0);
    };

    const scheduleUpdate = () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(updateVisibility);
    };

    updateVisibility();
    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);

    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.removeEventListener("scroll", scheduleUpdate);
      window.removeEventListener("resize", scheduleUpdate);
    };
  }, [regularButtonRef]);

  return isVisible;
}
